import { State } from "country-state-city";

// export const server = "http://localhost:8789/api/v1";
export const server = "https://server.deenovoschool.com/api/v1";

export const qrBaseUrl = "https://deenovoschool.com";

export const STATES_LIST = State.getStatesOfCountry("IN");

export const defaultUserImage = "";
